import flatMap from 'lodash/flatMap';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import sortBy from 'lodash/sortBy';
import uniqWith from 'lodash/uniqWith';

import {CohortSegment} from './types';

export function isGroupByEqual(groupByA, groupByB, _?: boolean) {
  return (
    groupByA.length === groupByB.length &&
    groupByA.every((aGrouping, groupIndex) => {
      const bGrouping = groupByB[groupIndex];
      if (!Array.isArray(aGrouping)) {
        return isEqual(aGrouping, bGrouping);
      } else if (!Array.isArray(bGrouping)) {
        return false;
      }
      const sortedAGrouping = sortBy(aGrouping, (aItem) => aItem.cohort.id);
      const sortedBGrouping = sortBy(bGrouping, (bItem) => bItem.cohort.id);
      return (
        sortedAGrouping.length === sortedBGrouping.length &&
        sortedAGrouping.every((aItem, itemIndex) =>
          isEqual(omit(aItem.cohort, [`name`]), omit(sortedBGrouping[itemIndex].cohort, [`name`])),
        )
      );
    })
  );
}

/**
 * Transforms bookmark group by to UI format by
 * consolidating negated and non-negated cohorts
 */
export function bookmarkGroupByToGroupBy(groupBy) {
  return groupBy.map((grouping) => {
    if (Array.isArray(grouping)) {
      return uniqWith(
        grouping,
        (a, b) =>
          (Number.isInteger(a.cohort.id) && Number.isInteger(b.cohort.id) && isEqual(a.cohort.id, b.cohort.id)) ||
          (a.cohort.raw_cohort && b.cohort.raw_cohort && isEqual(a.cohort.raw_cohort, b.cohort.raw_cohort)),
      ).map((item) => ({
        cohort: {
          ...(item.cohort.raw_cohort
            ? {
                raw_cohort: item.cohort.raw_cohort,
                name: item.cohort.name || item.cohort.raw_cohort.name,
              }
            : {
                id: item.cohort.id,
              }),
          negated: false,
        },
      }));
    }
    return grouping;
  });
}

/**
 * Transforms UI format group by to bookmark group by
 */
export function groupByToBookmarkGroupBy(groupBy, includeNegated = true) {
  return groupBy.map((grouping) => {
    if (Array.isArray(grouping)) {
      return flatMap(grouping as CohortSegment[], ({cohort}) => {
        const group = [
          {
            cohort: {
              ...cohort,
              negated: false,
            },
          },
          {
            cohort: {
              ...cohort,
              negated: true,
            },
          },
        ];
        return includeNegated ? group : [group[0]];
      });
    }
    return grouping;
  });
}
